function e(e){if(e){if(e.startsWith(`http://`))return e.replace(`http://`,`https://`);if(e.startsWith(`//`))return`https:${e}`}return e}export{e as addHttps};
//# sourceMappingURL=add-https.js.map